import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/pet"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60185 3.08527C7.86821 4.44005 7.20553 5.71105 6.12171 5.92414C5.03789 6.13723 3.94335 5.21171 3.67699 3.85694C3.41063 2.50216 4.07331 1.23116 5.15713 1.01807C6.24095 0.804978 7.33549 1.7305 7.60185 3.08527ZM12.4073 3.85745C12.6736 2.50267 12.011 1.23167 10.9271 1.01858C9.84331 0.80549 8.74877 1.73101 8.48241 3.08579C8.21605 4.44056 8.87873 5.71157 9.96255 5.92466C11.0464 6.13774 12.1409 5.21222 12.4073 3.85745ZM3.13932 8.21437C3.85676 7.80016 3.99064 6.68891 3.43836 5.73232C2.88607 4.77573 1.85676 4.33606 1.13932 4.75027C0.42188 5.16448 0.287996 6.27573 0.840281 7.23232C1.39257 8.18891 2.42188 8.62858 3.13932 8.21437ZM12.562 5.73256C12.0098 6.68914 12.1436 7.80039 12.8611 8.21461C13.5785 8.62882 14.6078 8.18914 15.1601 7.23256C15.7124 6.27597 15.5785 5.16472 14.8611 4.7505C14.1436 4.33629 13.1143 4.77597 12.562 5.73256ZM2.69091 10.9428L4.82259 8.1552C6.42358 6.0616 9.57647 6.0616 11.1775 8.1552L13.1236 10.7002C13.9116 11.7306 13.815 13.1851 12.8978 14.1023C12.0725 14.9276 10.797 15.0984 9.78373 14.5194L8.92937 14.0311C8.34877 13.6994 7.64077 13.6797 7.04266 13.9788L5.73939 14.6304C4.72027 15.14 3.48451 14.8815 2.75508 14.0062C2.02102 13.1253 1.99438 11.8536 2.69091 10.9428Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Pet16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Pet16 = createIcon(IconComponent);